<template>
  <div class="home-page">
    <van-sticky>
      <div class="video-box">
        <Video />
      </div>
    </van-sticky>
    <van-tabs :lazy-render="false" v-model="activeTab" animated sticky class="tabs" :before-change="beforeChangeTab">
      <van-tab v-for="(tabInfo, index) in tabList" :key="index" :title="tabInfo.title">
        <template #title>
          <icon-svg :name="index === activeTab ? `tab-${tabInfo.icon}-on` : `tab-${tabInfo.icon}`"
            class="tab-icon"
            :class="[`tab-icon-${index + 1}`]" />
        </template>
        <div class="tab-detail" :id="'tab-detail-'+ index">
          <img v-for="i in tabInfo.imgNum" :key="i" class="tab-image" @click="clickImg(tabInfo, i)"
            :src="require(`../assets/home/${tabInfo.icon}/${i}.${tabInfo.imgType}`)"
            alt="images" />
        </div>
      </van-tab>
    </van-tabs>
    <Like class="like-box"/>
  </div>
</template>

<script>
import wx from "weixin-js-sdk"
import Video from "@/components/video.vue";
import Like from "@/components/Like.vue";
export default {
  name: "Home",
  components: {
    Video,
    Like,
  },
  data() {
    return {
      activeTab: 0,
      tabList: [
        {
          title: "关于我们",
          icon: "about",
          imgNum: 4,
          imgType:'png'
        },
        {
          title: "校招岗位",
          icon: "jobs",
          imgNum: 2,
          imgType:'png'
        },
        {
          title: "校招流程",
          icon: "steps",
          imgNum: 2,
          imgType:'png'
        },
        {
          title: "Q&A",
          icon: "qa",
          imgNum: 3,
          imgType:'png'
        },
      ],
    };
  },
  created() {
    const params = {
      title: "加入我们，实现价值",
      desc: "卫宁健康2027校园招聘",
      link: process.env.VUE_APP_BASEURL,
      imgUrl: process.env.VUE_APP_SHARE+'share.png',
    };
    this.shareFunction(params);
  },
  methods: {
    // tab切换时重置滚动条
    beforeChangeTab() {
      const tabPanel = document.getElementById("tab-detail-" + this.activeTab);
      setTimeout(() => {
        tabPanel.scrollTop = 0;
      }, 100);
      return true;
    },
    clickImg(tabInfo, imgIndex){

      let host = window.location.host.indexOf('localhost') !== -1 ? 'campus.winning-health.com.cn':window.location.host

      // 校招岗位-校招岗位列表
      if(tabInfo.icon === 'jobs'){
        let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe0a1a1b805f873e3&redirect_uri=http%3A%2F%2F${host}%2Fstatic%2Fh5-recruitadmin%2F%23%2Fjob%2Flist%2Fcampus&response_type=code&scope=snsapi_base&state=news#wechat_redirect`
        console.log(url)
        window.open(url)
      }

      // 校招流程-快速推荐-（图片第2张）校招行程列表
      if(tabInfo.icon === 'steps' && imgIndex === 2 ){
        let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe0a1a1b805f873e3&redirect_uri=http%3A%2F%2F${host}%2Fstatic%2Fh5-recruitadmin%2F%23%2Fschedule%2Flist&response_type=code&scope=snsapi_base&state=news#wechat_redirect`
        console.log(url)
        window.open(url)
      }

      // 校招流程-投递通道-PC端（图片第5张），打开对应链接
      if(tabInfo.icon === 'steps' && imgIndex === 4){
        window.open('http://www.winning.com.cn/recurit-school.html')
      }

    },
    shareFunction(params) {
      const requestParam = {
        // 当前页面路径
        url: window.location.href,
      };
      this.$api
        .SYS_SHARE_INFO(requestParam)
        .then(function (res) {
          //console.log(res);
          wx.config({
            debug: false,// true开启调试模式,pc端会console.log手机端会alert
            appId: res.appid,// 必填，公众号的唯一标识，填自己的！
            timestamp: res.timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
            nonceStr: res.nonce_str,   // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名，见附录1
            jsApiList: [
              'updateTimelineShareData',
              'updateAppMessageShareData',

            ]
          })
          //分享配置
          wx.ready(function () {
            //好友
            wx.updateAppMessageShareData({
              title: params.title, // 分享时的标题
              desc:params.desc,
              link: params.link, // 分享时的链接
              imgUrl: params.imgUrl, // 分享时的图标
              success: function () {
                // Toast('设置分享朋友圈成功')
              }
            })
            //朋友圈
            wx.updateTimelineShareData({
              title: params.title,
              desc: params.desc,
              link: params.link,
              imgUrl: params.imgUrl,
              success: function () {
                // Toast('设置分享朋友成功')
              }

            })
          })
        })
        .catch(function (err) {
          //Toast(err)
          console.log(err);
        })
    },
  }
};
</script>

<style scoped>
.home-page {
  font-family: SourceHanSansCN-Regular;
  width: 100vmin;
  height: 100vh;
  overflow: hidden;
}

.video-box {
  width: 100%;
  height: 430px;
  max-height: 40vh;
  z-index: 10;
}

.tabs{
  z-index: 9;
}

.tab-icon {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
.tab-icon-1{
  width: 138px;
  height: 27px;
}
.tab-icon-2{
  width: 140px;
  height: 27px;
}
.tab-icon-3{
  width: 139px;
  height: 27px;
}
.tab-icon-4 {
  width: 87px;
  height: 27px;
}

::v-deep .van-tab__text {
  font-size: 28px;
  color: #626262;
  font-weight: 500;
}

::v-deep .van-tabs__line {
  top: 10px;
  height: 70px;
  width: 170px;
  background-color: transparent;
  background-image: url(../assets/icons/tab-active-bar.svg);
  background-position: center;
  background-size: 170px 70px;
}

::v-deep .van-tab--active {
  color: white;
  z-index: 100;
}

.tab-detail {
  height: calc(100vh - 430px - 88px);
  min-height: calc(100vh - 40vh - 88px);
  overflow-y: scroll;
  margin-bottom: 100px;
  /* 解决图片上下间隙 */
  font-size: 0;
  line-height: 0;
  list-style: none;
}

.tab-detail .tab-bg {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(#1A0082, #060036);
  /* 解决图片上下间隙 */
  font-size: 0;
  line-height: 0;
  list-style: none;
}

.tab-detail img, .tab-detail .tab-image {
  width: 100%;
  /* 解决图片上下间隙 */
  display: block;
  padding: 0;
  margin: 0;
  vertical-align: middle;
  overflow-y: scroll;
  z-index: 100;
}

#tab-detail-2 img:nth-child(3){
  cursor: pointer;
}

.like-box{
  position: relative;
  left: calc(50% - 80px);
}
</style>
